<simple-card
  [cardTitle]="'Portfolio summary'"
  [titleFontSize]="'20px'"
  [enableShadow]="true"
  [showHeader]="true"
  [contentLayout]="'default'"
  [style]="{ height: '292px' }"
>
  <div class="summary-card-content">
    <span class="summary-description">
      Get a unified view of your studies across all stages—from start-up through closeout. Quickly
      spot progress, compare performance, and identify potential risks—so you can act faster and
      with confidence.
    </span>
    <div class="summary-study-card-container">
      <div class="summary-study-card">
        <ng-container *ngIf="!isLoading; else startupSkeleton">
          <span class="summary-study-card-count">{{ startupStudiesCount }}</span>
          <p class="summary-study-card-description">
            <span class="summary-study-card-label">Studies in</span><br />
            <span class="summary-study-card-stage">Startup</span>
          </p>
        </ng-container>
        <ng-template #startupSkeleton>
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              width: '135px',
              height: '32px',
              'border-radius': '8px',
              'background-color': '#D6ECFC'
            }"
          >
          </ngx-skeleton-loader>
        </ng-template>
      </div>
      <div class="summary-study-card">
        <ng-container *ngIf="!isLoading; else enrollmentSkeleton">
          <span class="summary-study-card-count">{{ enrollmentStudiesCount }}</span>
          <p class="summary-study-card-description">
            <span class="summary-study-card-label">Studies in</span><br />
            <span class="summary-study-card-stage">Enrollment</span>
          </p>
        </ng-container>
        <ng-template #enrollmentSkeleton>
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              width: '135px',
              height: '32px',
              'border-radius': '8px',
              'background-color': '#D6ECFC'
            }"
          >
          </ngx-skeleton-loader>
        </ng-template>
      </div>
      <div class="summary-study-card">
        <ng-container *ngIf="!isLoading; else maintenanceSkeleton">
          <span class="summary-study-card-count">{{ maintenanceStudiesCount }}</span>
          <p class="summary-study-card-description">
            <span class="summary-study-card-label">Studies in</span><br />
            <span class="summary-study-card-stage">Maintenance</span>
          </p>
        </ng-container>
        <ng-template #maintenanceSkeleton>
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              width: '135px',
              height: '32px',
              'border-radius': '8px',
              'background-color': '#D6ECFC'
            }"
          >
          </ngx-skeleton-loader>
        </ng-template>
      </div>
      <div class="summary-study-card">
        <ng-container *ngIf="!isLoading; else closingSkeleton">
          <span class="summary-study-card-count">{{ closingStudiesCount }}</span>
          <p class="summary-study-card-description">
            <span class="summary-study-card-label">Studies in</span><br />
            <span class="summary-study-card-stage">Closeout</span>
          </p>
        </ng-container>
        <ng-template #closingSkeleton>
          <ngx-skeleton-loader
            appearance="line"
            [theme]="{
              width: '135px',
              height: '32px',
              'border-radius': '8px',
              'background-color': '#D6ECFC'
            }"
          >
          </ngx-skeleton-loader>
        </ng-template>
      </div>
    </div>
    <div class="summary-card-footer">
      <a routerLink="/portfolio" href="/portfolio" class="link">View my portfolio</a>
    </div>
  </div>
</simple-card>
